import axios from 'axios'
import _ from 'underscore'

axios.defaults.withCredentials = true

export default {
  getAll: function () {
    return axios.get(`${window.apiURL}api/user/smartlinks`)
  },
  get: function (id) {
    return axios.get(`${window.apiURL}api/user/smartlinks/${id}`)
  },
  getByRelease: function (id) {
    return axios.get(`${window.apiURL}api/user/smartlinks-release/${id}`)
  },
  save: function (item) {
    item = _.clone(JSON.parse(JSON.stringify(item)))

    if (item._id) {
      let id = item._id
      let data = item

      delete item._id
      delete item.createdAt
      delete item.updatedAt
      return axios.put(`${window.apiURL}api/user/smartlinks/${id}`, data)
    } else {
      return axios.post(`${window.apiURL}api/user/smartlinks`, item)
    }
  },
  getActivity: function (id) {
    return axios.get(`${window.apiURL}api/user/smartlinks/${id}/activity`)
  },
  getSmartlinkByKey: function (key) {
    return axios.get(`${window.apiURL}api/smartlinks/${key}`)
  }
}



// WEBPACK FOOTER //
// ./src/services/smartlinks.js